import { render } from "./SupplierManagement.vue?vue&type=template&id=94ebddc4&scoped=true"
import script from "./SupplierManagement.vue?vue&type=script&lang=js"
export * from "./SupplierManagement.vue?vue&type=script&lang=js"

import "./SupplierManagement.vue?vue&type=style&index=0&id=94ebddc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ebddc4"]])

export default __exports__